/*
 * Dutch names for the colour swatches of the Ownprint personalization block.
 *
 * The block shows the Shopify option value ("18k Gold Plated") next to the
 * field label and as the swatch tooltip. Those values stay English: the block
 * finds the variant by them, and Ownprint reads the order by them
 * (OWNPRINT.md). This only changes what the visitor reads: the label text,
 * title, aria-label and image alt. The hidden form value and
 * data-ownprint-swatch are left alone.
 *
 * The translations come from locales via the JSON in
 * blocks/product-photo-tips.liquid ([data-ownprint-labels]).
 */
(function () {
  if (window.__ownprintLabels) return;
  window.__ownprintLabels = true;

  var source = document.querySelector('[data-ownprint-labels]');
  if (!source) return;

  var labels;
  try {
    labels = JSON.parse(source.textContent);
  } catch (error) {
    return;
  }

  function translateSwatches() {
    var swatches = document.querySelectorAll('[data-ownprint-swatch]');
    for (var i = 0; i < swatches.length; i += 1) {
      var swatch = swatches[i];
      var name = labels[swatch.getAttribute('data-ownprint-swatch')];
      if (!name) continue;
      if (swatch.getAttribute('title') !== name) swatch.setAttribute('title', name);
      if (swatch.getAttribute('aria-label') !== name) swatch.setAttribute('aria-label', name);
      var image = swatch.querySelector('img');
      if (image && image.getAttribute('alt') !== name) image.setAttribute('alt', name);
    }

    var selected = document.querySelectorAll('[data-ownprint-swatch-selected]');
    for (var j = 0; j < selected.length; j += 1) {
      var translated = labels[selected[j].textContent.trim()];
      if (translated) selected[j].textContent = translated;
    }
  }

  translateSwatches();
  document.addEventListener('DOMContentLoaded', translateSwatches);

  // The block sets the selected name on every click, and rebuilds itself when
  // the theme re-renders the section. Translate again after each change; the
  // Dutch text is not in `labels`, so this settles after one pass.
  new MutationObserver(translateSwatches).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
  });
})();
